// Mock data for PlusPlus clone

export const companies = [
  { name: 'Melitta', logo: '/images/melita.webp' },
  { name: 'Wap', logo: '/images/wap.webp' },
  { name: 'Weg', logo: '/images/weg.webp' },
  { name: 'SPX', logo: '/images/spx.webp' },
  { name: 'Estrela', logo: '/images/estrela.webp' },
  { name: 'Caterpillar', logo: '/images/caterpila.webp' },
  { name: 'Ecad', logo: '/images/ecad.webp' },
  { name: 'Santander', logo: '/images/santander.webp' },
  { name: 'Killing', logo: '/images/killing.webp' },
  { name: 'Dux', logo: '/images/dux.webp' },
  { name: 'Sebrae', logo: '/images/sebrae.webp' },
  { name: 'XP', logo: '/images/xp.webp' },
  { name: 'Waaw', logo: '/images/waaw.webp' },
];

export const features = [
  {
    icon: 'Hand',
    title: 'Um Toque',
    description: 'Basta tocar um de nossos produtos inteligentes em um iPhone ou Android.',
  },
  {
    icon: 'BanIcon',
    title: 'Não precisa de App',
    description: 'Não é necessário instalar aplicativo para funcionar.',
  },
  {
    icon: 'Smartphone',
    title: 'Compatível',
    description: 'Compatível com Android e iOS.',
  },
];

export const sharingMethods = [
  {
    title: 'NameDrop',
    description: 'Compartilhe seu contato apenas aproximando seu celular.',
    image: '/images/aproxima_cel-2.webp',
  },
  {
    title: 'Link na Bio',
    description: 'Compartilhe seu cartão de visita digital através de um link.',
    image: '/images/link.webp',
  },
  {
    title: 'Wallet e Apple Watch',
    description: 'Tenha seu cartão de visita digital na Wallet do seu celular.',
    image: '/images/wallet.webp',
  },
];

export const products = [
  {
    id: 'metal',
    name: 'Cartão de Metal Eletrônico',
    subtitle: 'Personalizado',
    tag: 'Novo',
    description: 'O único Cartão de Visita Eletrônico de METAL do Brasil.',
    oldPrice: 347,
    price: 187,
    image: '/images/metalcard.webp',
  },
  {
    id: 'personalizado',
    name: 'Cartão de Visita Eletrônico',
    subtitle: 'Personalizado',
    tag: 'Promo',
    description: 'A maneira mais rápida de compartilhar suas informações.',
    oldPrice: 127,
    price: 97,
    image: '/images/card_personalizado.webp',
  },
  {
    id: 'bamboo',
    name: 'Cartão Eco Bamboo',
    subtitle: '',
    tag: 'Novo',
    description: 'O único Cartão de Visita Eletrônico feito de madeira do Brasil.',
    oldPrice: 247,
    price: 137,
    image: '/images/bambucard.webp',
  },
  {
    id: 'classic',
    name: 'Cartão de Visita Eletrônico',
    subtitle: 'Classic',
    tag: 'Promo',
    description: 'A maneira mais rápida de compartilhar suas informações.',
    oldPrice: 87,
    price: 67,
    image: '/images/cartao-classic.webp',
  },
  {
    id: 'tag',
    name: 'Adesivo Eletrônico - Tag',
    subtitle: '',
    tag: 'Promo',
    description: 'Cole em seu celular e aproxime para compartilhar seu contato!',
    oldPrice: 87,
    price: 67,
    image: '/images/tag-reduzida.webp',
  },
  {
    id: 'display',
    name: 'Display Personalizado',
    subtitle: '',
    tag: 'Novo',
    description: 'Display 100% personalizado com sua logo, imagens e cores.',
    oldPrice: 157,
    price: 97,
    image: '/images/display_personalizado.webp',
  },
];

export const faqs = [
  {
    q: 'Onde encontro meu PIN?',
    a: 'Atrás do seu cartão, abaixo do QRCode você encontra a numeração PIN.',
  },
  {
    q: 'A PlusPlus cobra mensalidade?',
    a: 'O cartão físico é pago uma vez e já abre com o plano grátis. Recursos avançados do cartão podem ter planos opcionais, que você vê dentro do cartão quando o ativa. O que você configurou nunca é apagado.',
  },
  {
    q: 'Quantas vezes eu consigo editar meu perfil?',
    a: 'Quantas vezes você precisar! Você pode redefinir completamente o seu perfil, mudar fotos, descrição, links e tudo que for necessário, basta editar seu perfil dentro do seu painel online.',
  },
  {
    q: 'Funciona em qualquer celular?',
    a: 'Sim! Funciona em qualquer celular iPhone ou Android. Se o celular não tiver sensor de aproximação (NFC) basta fazer a leitura do QRCode com a câmera ou usando um app leitor de QRCode. Além disso, seu perfil é facilmente compartilhado através do seu link.',
  },
  {
    q: 'Preciso de conexão com a internet?',
    a: 'Você precisa de internet apenas no momento da troca de contato, pois seu perfil é aberto no navegador. O receptor não precisa instalar nada.',
  },
  {
    q: 'Como funciona o painel administrativo?',
    a: 'No painel você pode gerenciar cartões, ver leads capturados, exportar relatórios, personalizar cores e capa, adicionar links ilimitados e muito mais.',
  },
];

export const testimonials = [
  {
    name: 'Roberto Silva',
    role: 'CEO, TechCorp',
    text: 'A PlusPlus revolucionou a forma como minha equipe compartilha contatos. Prático e sustentável!',
  },
  {
    name: 'Fernanda Costa',
    role: 'Diretora Comercial, Melitta',
    text: 'Capturamos mais leads em feiras do que nunca. O ROI foi incrível no primeiro mês.',
  },
  {
    name: 'André Luiz',
    role: 'Consultor de Vendas',
    text: 'Nunca mais fiquei sem cartão. É só aproximar e pronto, contato compartilhado.',
  },
];
